export default __webpack_public_path__ + "static/media/38-min.626f3d0a.jpg";